export default {
      id: "icon--menu-old-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--menu-old-usage",
      toString: function () {
        return this.url;
      }
    }